import { createContext } from 'react'

export const FeatureFlagContext = createContext<string[]>([])
